import React from "react";
import { FaPencil } from "react-icons/lib/fa";
import { Button } from "reactstrap";
import { withNamespaces } from "react-i18next";

const PopupContent = props => {
  const { t } = props;

  if (props.hasOwnProperty("status")) {
    var colour = "";
    var prowType = "";

    switch (props.status) {
      case 1: //Footpath
        prowType = t("FP");
        colour = "#B141E3";
        break;
      case 2: //Bridleway
        prowType = t("BW");
        colour = "#1FAE0E";
        break;
      case 3: //BOAT
        prowType = t("BOAT");
        colour = "#7F4229";
        break;
      case 4: //RB
        prowType = t("RB");
        colour = "#31EE03";
        break;
      default:
        prowType = t("Unclassified");
        colour = "#000000";
    }
  }

  return (
    <div>
      <h4 style={{ color: colour, textAlign: "center" }}>{prowType}</h4>
      <h6 style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>{t("popup-prow-identifier")} <b>{props.row_code}</b></h6>
      {/*<p>{t("popup-prow-length")} {Math.round(props.length_kilometres * 100) / 100}km</p>*/}
      <Button block color="primary" onClick={props.reportIssue}>
        <FaPencil className="icon" /> {t("popup-report-issue-button")}
      </Button>
    </div>
  );
};

export default withNamespaces()(PopupContent);



// WEBPACK FOOTER //
// ./src/PopupContent.jsx